import { render, staticRenderFns } from "./eod-routes.vue?vue&type=template&id=25efcce0&scoped=true"
import script from "./eod-routes.vue?vue&type=script&lang=js"
export * from "./eod-routes.vue?vue&type=script&lang=js"
import style0 from "./eod-routes.vue?vue&type=style&index=0&id=25efcce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25efcce0",
  null
  
)

export default component.exports